<template>
	<footer class="footer" v-if="$route.name !=  'ticket'">
		<div class="container">


			<div class="copyright">
				<b>&copy; {{ new Date().getFullYear() }} <a href="https://cambodiatechex.gov.kh" target="_blank"><span class="text-primary">Cambodia Tech Expo</span></a></b>. All rights reserved.
			</div>
			<div class="copyright text-center">
				<!-- <div class="md-layout-item md-small-size-100 md-size-100">
					<img src="@/assets/img/sponsor.png" />
				</div> -->
				Developed by <a href="https://bongkert.com" target="_blank"><b><span class="text-primary">Bongkert Solutions</span></b></a>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue